export default {
  alias      : 'dependencia',
  route      : '/app/general/dependencia',
  hash       : true,
  store      : true,
  key        : 'iddependencia',
  name       : 'depe_nombre',
  selectable : true,
  
  relations : [
    {
      attribute : 'depe_depende',
      alias     : 'sede',
      module    : 'dependencia',
    },
  ],
  default : {
    iddependencia          : null,
    depe_nombre            : null,
    depe_abreviado         : null,
    depe_sigla             : null,
    depe_representante     : null,
    depe_cargo             : null,
    depe_depende           : null,
    depe_superior          : {},
    depe_tipo              : null,
    depe_proyectado        : null,
    depe_estado            : null,
    depe_observaciones     : null,
    depe_idusuario         : null,
    depe_idusuariotransp   : null,
    depe_recibetramite     : null,
    depe_agente            : null,
    depe_diasmaxenproceso  : null,
    depe_idusuarioreclamo  : null,
    depe_rrhh              : null,
    created_at             : null,
    updated_at             : null,
    depe_imagen_header     : null,
    depe_imagen_footer     : null,
    depe_mesa_virtual      : null,
    depe_dni               : null,
    depe_ciudad            : null,
    depe_minuto_tolerancia : null,
    gestiona_proyecto      : null
  },
}
